import { useState } from 'react';
import type {
    PurchaseOrderBillingStatus,
    PurchaseOrderPaymentStatus
} from '../../../services/purchaseOrders';

// The export dialog's own filter selection - independent of whatever the
// table is showing. All four default to empty, meaning unrestricted.
export interface PurchaseOrderExportFilters {
    practiceId: string | null;
    vendorId: string | null;
    billingStatus: PurchaseOrderBillingStatus | null;
    paymentStatus: PurchaseOrderPaymentStatus | null;
}

const EMPTY_EXPORT_FILTERS: PurchaseOrderExportFilters = {
    practiceId: null,
    vendorId: null,
    billingStatus: null,
    paymentStatus: null
};

export interface UseExportPurchaseOrderFiltersResult {
    filters: PurchaseOrderExportFilters;
    setPracticeId: (value: string | null) => void;
    setVendorId: (value: string | null) => void;
    setBillingStatus: (value: PurchaseOrderBillingStatus | null) => void;
    setPaymentStatus: (value: PurchaseOrderPaymentStatus | null) => void;
}

export function useExportPurchaseOrderFilters(): UseExportPurchaseOrderFiltersResult {
    const [filters, setFilters] = useState<PurchaseOrderExportFilters>(EMPTY_EXPORT_FILTERS);

    return {
        filters,
        setPracticeId: (practiceId) => setFilters((prev) => ({ ...prev, practiceId })),
        setVendorId: (vendorId) => setFilters((prev) => ({ ...prev, vendorId })),
        setBillingStatus: (billingStatus) => setFilters((prev) => ({ ...prev, billingStatus })),
        setPaymentStatus: (paymentStatus) => setFilters((prev) => ({ ...prev, paymentStatus }))
    };
}

export const EXPORT_BILLING_STATUS_OPTIONS: {
    value: PurchaseOrderBillingStatus;
    label: string;
}[] = [
    { value: 'not_billed', label: 'Not billed' },
    { value: 'billed', label: 'Billed' }
];

export const EXPORT_PAYMENT_STATUS_OPTIONS: {
    value: PurchaseOrderPaymentStatus;
    label: string;
}[] = [
    { value: 'paid', label: 'Paid' },
    { value: 'unpaid', label: 'Not paid' }
];
